import { WidgetType } from 'domain/entity/widget';
import WidgetData, { ColorType, WidgetDataAvailability, WidgetDescription } from 'domain/entity/widgetData';
import { SerieBorder } from 'domain/entity/widgets/ChartData';

export type ChartColors = {
    type: ColorType;
    byDefault: string;
};

export enum FillPiePattern {
    DASHED = 'DASHED',
    SOLID = 'SOLID',
}

export type PieSeries = {
    title: string;
    value: number;
    color: ChartColors;
    fillPattern: SerieBorder;
};

interface PieData extends WidgetData {
    readonly series: PieSeries[];
    readonly units: string;
    readonly title: string;
}

class PieData implements PieData {
    type = WidgetType.PIE;

    constructor(
        readonly series: PieSeries[],
        readonly units: string,
        readonly title: string,
        readonly dataAvailability: WidgetDataAvailability,
        readonly description: WidgetDescription
    ) {}
}

export default PieData;
